export default {
    editor: {
        generateWithAi: 'Generate with AI',
        improveWriting: 'Improve writing',
        fixSpelling: 'Fix spelling and grammar',
        simplifyWriting: 'Simplify writing',
        makeLonger: 'Make longer',
        makeShorter: 'Make shorter',
        ai: 'AI',
    },
};
